import { gql } from "@apollo/client/core";

export default gql`
    fragment DisasterEvent_Minimal on Event {
        id
        title
    }
`
